var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerySad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 39.9989C31.0449 39.9989 39.9989 31.0449 39.9989 19.9995C39.9989 8.95407 31.0449 0 19.9995 0C8.95407 0 0 8.95407 0 19.9995C0 31.0449 8.95407 39.9989 19.9995 39.9989Z",
    fill: "#CC2334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84216 13.3091C8.62579 13.2975 8.44531 13.4696 8.44531 13.6859C8.44531 13.858 8.56036 14.0068 8.72711 14.0501C9.277 14.1936 10.5266 14.6147 11.5409 15.6543C10.7029 16.2285 10.153 17.1932 10.153 18.2855C10.153 20.046 11.58 21.474 13.3415 21.474C15.103 21.474 16.53 20.0471 16.53 18.2855C16.53 14.0216 10.4675 13.3999 8.84321 13.3091H8.84216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1574 13.3091C29.5331 13.3989 23.4707 14.0205 23.4707 18.2855C23.4707 20.046 24.8977 21.474 26.6592 21.474C28.4207 21.474 29.8477 20.0471 29.8477 18.2855C29.8477 17.1932 29.2978 16.2285 28.4598 15.6543C29.473 14.6158 30.7237 14.1936 31.2735 14.0501C31.4403 14.0068 31.5554 13.8569 31.5554 13.6859C31.5554 13.4696 31.3749 13.2975 31.1585 13.3091H31.1574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4866 30.4656C25.1879 30.4656 24.8945 30.3168 24.7235 30.0455C24.6549 29.9389 23.0865 27.5399 20.0004 27.5399C16.9143 27.5399 15.3365 29.9569 15.2679 30.0603C14.9934 30.473 14.4351 30.588 14.0214 30.3157C13.6066 30.0424 13.4905 29.4882 13.7617 29.0724C13.8504 28.9363 15.9845 25.7383 20.0015 25.7383C24.0185 25.7383 26.1652 28.95 26.2507 29.0872C26.5146 29.5094 26.3858 30.0645 25.9647 30.3284C25.8159 30.4213 25.6512 30.4656 25.4877 30.4656H25.4866Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySad);
export default __webpack_public_path__ + "static/media/very-sad.d428ab48b16a6416e04f4a576a85010b.svg";
export { ForwardRef as ReactComponent };